<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn slot="activator" icon>
        {{formando.codigo}}
      </v-btn>
      <v-card>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Editar Formando</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <h3 class="headline mb-1">{{formando.email}}</h3>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12>
              <v-text-field
                id="codigo"
                name="codigo"
                label="Código"
                v-model="formando.codigo"
                required></v-text-field>
            </v-flex>
           <v-flex xs12>
              <v-text-field
                id="nomecompleto"
                name="nomecompleto"
                label="Nome Completo"
                v-model="formando.nomecompleto"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="nome"
                name="nome"
                label="Nome"
                v-model="formando.nome"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="sobrenome"
                name="sobrenome"
                label="Sobrenome"
                v-model="formando.sobrenome"
                required></v-text-field>
            </v-flex>
              

   
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click.native="deleteFormando">Apagar Formando</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.native="editarFormando">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "FormandoEditar",
  props: {
    projetoNo: {
      type: String,
      required: true
    },
    formando: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    editarFormando() {
      let updates = {};
      updates[
        "/projetos/" +
          this.projetoNo +
          "/formandos/" +
          this.formando[".key"] +
          "/nomecompleto"
      ] = this.formando.nomecompleto;
      updates[
        "/projetos/" +
          this.projetoNo +
          "/formandos/" +
          this.formando[".key"] +
          "/codigo"
      ] = this.formando.codigo;
      updates[
        "/projetos/" +
          this.projetoNo +
          "/formandos/" +
          this.formando[".key"] +
          "/nome"
      ] = this.formando.nome;
      updates[
        "/projetos/" +
          this.projetoNo +
          "/formandos/" +
          this.formando[".key"] +
          "/sobrenome"
      ] = this.formando.sobrenome;
      updates["/users/" + this.formando[".key"] + "/nome"] = this.formando.nome;
      updates[
        "/users/" + this.formando[".key"] + "/sobrenome"
      ] = this.formando.sobrenome;
      this.$db.ref().update(updates);
      this.dialog = false;
    },
    deleteFormando() {
      const confirmar = confirm("DELETAR - Tem certeza?");
      if (confirmar === true) {
        this.$db
          .ref(
            "/projetos/" +
              this.projetoNo +
              "/formandos/" +
              this.formando[".key"]
          )
          .remove();
        this.dialog = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FormandoEditar.vue